import React from 'react';
import { CSSTransitionGroup } from '../../../../node_module_clones/react-transition-group';

import './TaskListItemDeleteButton.scss';

type Props = {
    show: boolean;
    DeleteIcon: React.ComponentType;
    onDelete?: () => void;
};

const TaskListItemDeleteButton: React.FC<Props> = ({ show, DeleteIcon, onDelete }) => {
    const handlePointerUp = (event: React.PointerEvent<HTMLDivElement>) => {
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        onDelete?.();
    };

    const button = show ? (
        <div className="TaskListItemDeleteButton" onPointerUp={handlePointerUp}>
            <div className="background" />
            <DeleteIcon />
        </div>
    ) : null;

    return (
        <div className="task-list-item-delete-button-container">
            <CSSTransitionGroup
                transitionName="slide"
                transitionAppear
                transitionAppearTimeout={200}
                transitionEnterTimeout={200}
                transitionLeaveTimeout={200}
            >
                {button}
            </CSSTransitionGroup>
        </div>
    );
};

export default TaskListItemDeleteButton;
